import { render, staticRenderFns } from "./ListAdditionalResources.vue?vue&type=template&id=09f8174c&"
import script from "./ListAdditionalResources.vue?vue&type=script&lang=js&"
export * from "./ListAdditionalResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09f8174c')) {
      api.createRecord('09f8174c', component.options)
    } else {
      api.reload('09f8174c', component.options)
    }
    module.hot.accept("./ListAdditionalResources.vue?vue&type=template&id=09f8174c&", function () {
      api.rerender('09f8174c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configuration/AdditionalResources/ListAdditionalResources.vue"
export default component.exports